import React, { useRef, useEffect, useCallback, useState} from 'react';
import SubPatchContent from "components/subpatch/SubPatchContent.js";
import {connect} from 'react-redux';
import {useWindows} from "components/windows/useWindows.js";


const CustomSubPatch = ({subpatch, forceShow}) => { 
    const {sizeRef, ordering, setOrdering} = useWindows();
    const elements = useRef({});

    return (
        <div className="custom-subpatch">
            <SubPatchContent
              isInsideWindow={true}
              sizeRef={sizeRef}
              elements={elements}
              isInstrumentView={true}
              forceShow={forceShow}
              customMode={"custom"}
              setOrdering={setOrdering}
              ordering={ordering}
              subpatch={subpatch}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomSubPatch);
